export enum Consents {
    LEARN_TIME_INFO_READ = 'learnTimeInfoRead',
}
